const ALLOWED_TAGS = new Set([
  "A",
  "B",
  "BLOCKQUOTE",
  "BR",
  "CODE",
  "DIV",
  "EM",
  "H1",
  "H2",
  "H3",
  "H4",
  "H5",
  "H6",
  "HR",
  "I",
  "LI",
  "OL",
  "P",
  "PRE",
  "S",
  "SPAN",
  "STRONG",
  "SUB",
  "SUP",
  "U",
  "UL"
]);

const ALLOWED_ATTRS = new Set(["href", "target", "rel", "title"]);

const isSafeHref = (value: string) => {
  const trimmed = value.trim();
  if (!trimmed) return false;

  return /^(https?:|mailto:|tel:|\/|#)/i.test(trimmed);
};

export const sanitizeChapterHtml = (html: string) => {
  if (!html) return "";

  const trimmed = html.trim();

  if (!trimmed.includes("<")) {
    return trimmed
      .split(/\r?\n\s*\r?\n/g)
      .map((paragraph) => paragraph.trim())
      .filter(Boolean)
      .map((paragraph) => `<p>${paragraph.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\n/g, "<br />")}</p>`)
      .join("");
  }

  if (typeof window === "undefined" || typeof window.DOMParser === "undefined") {
    return trimmed;
  }

  const doc = new window.DOMParser().parseFromString(trimmed, "text/html");

  const walk = (node: Node) => {
    if (node.nodeType === Node.TEXT_NODE) return;

    if (node.nodeType !== Node.ELEMENT_NODE) {
      node.parentNode?.removeChild(node);
      return;
    }

    const element = node as HTMLElement;
    const tagName = element.tagName.toUpperCase();

    if (!ALLOWED_TAGS.has(tagName)) {
      const parent = element.parentNode;
      if (!parent) return;

      while (element.firstChild) {
        parent.insertBefore(element.firstChild, element);
      }

      parent.removeChild(element);
      return;
    }

    Array.from(element.attributes).forEach((attr) => {
      const name = attr.name.toLowerCase();

      if (name.startsWith("on") || !ALLOWED_ATTRS.has(name)) {
        element.removeAttribute(attr.name);
        return;
      }

      if (tagName !== "A" && name === "href") {
        element.removeAttribute(attr.name);
        return;
      }

      if (tagName === "A" && name === "href" && !isSafeHref(attr.value)) {
        element.removeAttribute(attr.name);
        return;
      }
    });

    if (tagName === "A") {
      const target = element.getAttribute("target");
      if (target === "_blank") {
        element.setAttribute("rel", "noopener noreferrer");
      }
    }

    Array.from(element.childNodes).forEach(walk);
  };

  Array.from(doc.body.childNodes).forEach(walk);
  return doc.body.innerHTML;
};
